import { Address } from "everscale-inpage-provider"

export function getAvatarUrlByAddress(address: Address | string) {
  return `https://api.dicebear.com/8.x/rings/svg?seed=${address.toString()}`
}
